export const getAppInstanceId = () => {
  const appInstanceId = sessionStorage.getItem('app_instance_id')
  
  return !appInstanceId ? window.GLOBAL_APP_ID : appInstanceId
}
  


// WEBPACK FOOTER //
// ./src/helpers/getAppInstanceId.js